import { CustomerLiteModel } from 'api-hooks/customer';
import { GuestLiteModel } from 'api-hooks/guest';
import { SaleLiteModel } from 'api-hooks/sale/common';
import { Expose, Type } from 'class-transformer';
import { ProjectStatusEnum } from 'common/constants/enum';
import { CommonParamInput } from 'common/repositories/common.model';

// Enum

export enum SaleProjectEnum {
  draft_removal = 'draft_removal',
  none = 'none',
  pending_removal = 'pending_removal',
}

// Model
export class AddInvoicesModel {
  id: string;

  @Type(() => SaleLiteModel)
  items: SaleLiteModel[];
}

export class ProjectCustomerModel {
  id: string;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;
}

export class ProjectGuestModel {
  id: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class ItineraryModel {
  id: string;
  route: string;
  description: string;

  @Expose({ name: 'is_complete' })
  isComplete: boolean;

  @Type(() => Date)
  date: Date;
}

export class ProjectModel {
  id: string;
  code: string;
  name: string;
  description: string;
  status: ProjectStatusEnum;

  @Expose({ name: 'project_customers' })
  @Type(() => ProjectCustomerModel)
  projectCustomers: ProjectCustomerModel[];

  @Expose({ name: 'project_guests' })
  @Type(() => ProjectGuestModel)
  projectGuests: ProjectGuestModel[];

  @Expose({ name: 'project_itineraries' })
  @Type(() => ItineraryModel)
  projectItineraries: ItineraryModel[];

  @Type(() => SaleLiteModel)
  sales: SaleLiteModel[];

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class ProjectLiteModel {
  id?: string;
  code: string | null;
  description: string;
  name: string | null;
  status: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;
}

// Input

export type ItineraryInput = {
  id?: string;
  date: Date | null;
  route: string | null;
  description: string;
  isComplete: boolean;
};

export type CustomerInput = {
  id?: string;
  customerId: string;
};

export type GuestInput = {
  id?: string;
  guestId: string;
};

export type SaleInput = {
  refId: string;
};

export type getProjectsInput = {
  params: CommonParamInput;
};

export type getProjectInput = {
  id: string;
};

export type ProjectMutationInput = {
  code: string;
  name: string;
  description: string;
  projectCustomers: CustomerInput[];
  projectGuests: GuestInput[];
  projectItineraries: ItineraryInput[];
  sales: SaleInput[];
};

export type ProjectUpdateInput = {
  projectId: string;
  body: ProjectMutationInput;
};

export type ProjectDeleteInput = {
  projectId: string;
};

export type AddToProjectInput = {
  saleRefId: string;
};

export type ProjectUpdateSales = {
  projectId: string;
  body: AddToProjectInput[];
};

export type ProjectDeleteSales = {
  projectId: string;
  saleRefId: string;
};
